export default __webpack_public_path__ + "static/lframe-debt-con-v2-59d0bfdae1b645822aac93d423203024.png";